import colorPallete, { bodyFonts, elevation, headlineFonts, labelFonts } from "@DSG/MobiusOverrides/styles/variables";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Phone from "@insite/mobius/Icons/Phone";
import Img from "@insite/mobius/Img/Img";
import { GridContainer, GridItem, Link } from "@insite/mobius/index";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser"
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

type Props = OwnProps;
// this is used to help ensure that the names match between props.fields and definition.fieldDefinitions[].name
const enum fields {
    pageTitle = "pageTitle",
}

interface OwnProps extends WidgetProps  {
    fields: {
        [fields.pageTitle]: string;
    };
}

export interface DsgStaticPageTitleStyles {
    pageTitle?: InjectableCss;
}


export const dsgStaticPageTitleStyles: DsgStaticPageTitleStyles = {
    pageTitle: {
        css: css`
            font: ${headlineFonts.headline1SemiBoldSm.fontWeight}  ${headlineFonts.headline1SemiBoldSm.fontSize}/ ${headlineFonts.headline1SemiBoldSm.lineHeight}  ${headlineFonts.headline1SemiBoldSm.fontFamily};
            margin: 0 0 24px;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                       font-size: ${headlineFonts.headline1SemiBoldLg.fontSize};
                       line-height: ${headlineFonts.headline1SemiBoldLg.lineHeight};
                    `,
                ],
                "min",
            )}
        `
    },
}

const styles = dsgStaticPageTitleStyles;

const DsgStaticPageTitle:React.FC<Props> = ({ fields }) => {
   return (
        <Typography as="h1" variant="h2" {...styles.pageTitle}>
            {fields.pageTitle}
        </Typography>
    );
    
};



const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            fieldType: "General",
            name: fields.pageTitle,
            editorTemplate: "TextField",
            displayName: "Page Title",
            defaultValue: ""
        },
    ],
};

const widgetModule: WidgetModule = {
    component: DsgStaticPageTitle,
    definition,
};

export default widgetModule;
